module.exports = __webpack_public_path__ + "img/enat.1bbea4e9.png";